import React from "react";

interface CameraIconProps {
  size?: number; // Optional size for scaling
  color?: string; // Optional stroke/fill color
  className?: string; // Optional additional styling via class
}

export const CameraIcon: React.FC<CameraIconProps> = ({
  size = 64,
  color = "black",
  className,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      width={size}
      height={size}
      fill="none"
      stroke={color}
      strokeWidth="2"
      className={className} // Allows external styling
    >
      <rect x="10" y="18" width="44" height="34" rx="4" ry="4" fill="white" />
      <circle cx="32" cy="35" r="10" fill="none" stroke={color} />
      <circle cx="32" cy="35" r="3" fill={color} />
      <rect x="16" y="10" width="8" height="8" fill="white" stroke={color} />
    </svg>
  );
};
